export function neighborhoodGuidePath(name) {
  const canonical = String(name || "Puerto Rico")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .split(/[^a-zA-Z0-9]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");
  return `/${canonical || "PuertoRico"}`;
}
